import { useState, type FormEvent, type ReactNode } from "react";
import { Button } from "../components/ui/Button";
import { useSiteContent } from "../lib/content";
import type { SiteContent } from "../lib/siteContent";

export function AdminSaveForm({
  title,
  hint,
  children,
  build,
}: {
  title: string;
  hint?: string;
  children: ReactNode;
  build: (form: FormData) => SiteContent;
}) {
  const { content, save, loading } = useSiteContent();
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [ok, setOk] = useState(false);

  if (loading) {
    return <p className="text-muted">A carregar…</p>;
  }

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSaving(true);
    setMessage(null);
    const error = await save(build(new FormData(event.currentTarget)));
    setSaving(false);
    setOk(!error);
    setMessage(error ?? "Guardado. O site público já usa este texto.");
  };

  return (
    <form onSubmit={onSubmit} className="max-w-3xl space-y-5">
      <div>
        <h1 className="font-heading text-2xl font-semibold text-primary">{title}</h1>
        {hint && <p className="mt-1 text-sm text-muted">{hint}</p>}
      </div>
      {children}
      {message && (
        <p className={ok ? "text-sm text-accent-terminal" : "text-sm text-urgent"}>{message}</p>
      )}
      <Button type="submit" disabled={saving}>
        {saving ? "A guardar…" : "Guardar"}
      </Button>
      <input type="hidden" name="_base" value={JSON.stringify(content)} />
    </form>
  );
}

export function parseBase(form: FormData): SiteContent {
  return JSON.parse(String(form.get("_base"))) as SiteContent;
}
